import React, { useMemo } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';

import {
	getItemTreeCount,
	type LinksMenuExtensionActions,
} from '../../../controllers/use-links-menu-parameters-and-actions';
import type { LinksMenuParameters } from '../../../types';

import { LinksMenuItemTree } from './links-menu-item-tree';
import { NewItemButton } from './new-item-button';

const itemsTabStyles = xcss({
	width: '100%',
	paddingTop: 'space.200',
});

const itemsTreeStyles = xcss({
	marginTop: 'space.200',
});

export type ItemsTabProps = {
	extensionActions: LinksMenuExtensionActions;
	extensionParameters: LinksMenuParameters;
};

export const ItemsTab = ({
	extensionParameters,
	extensionActions,
}: ItemsTabProps): React.JSX.Element => {
	const totalItemCount = useMemo(
		() => getItemTreeCount(extensionParameters.items),
		[extensionParameters.items],
	);
	return (
		<Flex direction="column" xcss={itemsTabStyles}>
			<NewItemButton extensionActions={extensionActions} numberItems={totalItemCount} />
			<Flex direction="column" xcss={itemsTreeStyles}>
				{extensionParameters.items && (
					<LinksMenuItemTree
						extensionActions={extensionActions}
						nodes={extensionParameters.items}
						numberItems={totalItemCount}
					/>
				)}
			</Flex>
		</Flex>
	);
};
